module.exports = __webpack_public_path__ + "static/media/Servine_gaussian2.fc7f800a.png";